import useWidget from './useWidget'
import { rendererFor } from './renderers'

export default function WidgetRenderer({ widget }) {
  const { data, isReady } = useWidget(widget.code)
  const renderer = rendererFor(widget.component)

  if (!renderer) return null

  const { Component, propsFor } = renderer

  return <Component {...propsFor(data ?? [], widget.options ?? {})} title={widget.name} isReady={isReady} />
}
